import React from "react";
import {Route} from "react-router-dom";
import Genders from "../../views/genders/list";
import RequireAuthentication from "../../hoc/authentication/requireAuthentication";
import Cookies from "js-cookie";
import {sessionStore} from "../../utils/sessionStore";

let routes = [];
const token = sessionStore.get("token") ?? (Cookies.get("_f") ? JSON.parse(Cookies.get("_f").toString()) : null);

if (token) {
    routes.push([
        <Route
            path="/genders"
            component={RequireAuthentication(Genders)}
            key="genders"
            exact
        />,
    ])
}

export default routes;
